import { ReactElement } from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'
import type { ProjectChangeCard } from '../utils'
import DecisionButtons, { ChangeDecision } from './DecisionButtons'

interface Props {
  card: ProjectChangeCard
  decision: ChangeDecision | undefined
  onDecide: (approved: boolean) => void
}

/** One change the agent wants to make: what, where, the data it sends, and the decision. */
const ChangeApprovalItem = ({ card, decision, onDecide }: Props): ReactElement => (
  <Box
    sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 1 }}
    data-cy="ai-chat-change-approval-item"
  >
    <Typography variant="body2" fontWeight={500}>
      {card.changeSummary ?? 'Änderung am Projekt'}
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center" mt={0.5} minWidth={0}>
      <Chip label={card.method} size="small" variant="outlined" />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontFamily: 'monospace', overflowWrap: 'anywhere' }}
      >
        {card.path}
      </Typography>
    </Stack>
    {card.body && (
      <Box component="details" mt={0.5}>
        <Typography component="summary" variant="caption" sx={{ cursor: 'pointer' }}>
          Gesendete Daten
        </Typography>
        <Box component="pre" sx={{ m: 0, mt: 0.5, maxHeight: 200, overflow: 'auto', fontSize: 11 }}>
          {card.body}
        </Box>
      </Box>
    )}
    <DecisionButtons decision={decision} onDecide={onDecide} />
  </Box>
)

export default ChangeApprovalItem
